
import { useEffect, useMemo, useState } from 'react';


export const useUndoData = (graphData) => {
    const [undoData, setUndoData] = useState([]);

    window.hUndo = undoData;
    
    function clearUndoData() {
        setUndoData([]);
    }
    
    function addUndoLevel(operation_info, oldGraphData, diffSummary) {
        const undoLevel = {ts: Date.now(), operation_info, oldGraphData, diffSummary};
        setUndoData(prevData => [...prevData, undoLevel]);
    }

    function undoToLevel(entry) {
        const idx = undoData.indexOf(entry);
        if (idx < 0) throw new Error("Undo level not found");
        setUndoData(undoData.slice(0, idx));
        for (let node of entry.oldGraphData.nodes) {
            // delete traces where run == 2 ('Running')
            for (let msId in node.trace) {
                const fetcherNames = Object.keys(node.trace[msId]);
                for (let fetcherName of fetcherNames) {
                    if (node.trace[msId][fetcherName].run === 2) {
                        delete node.trace[msId][fetcherName];
                    }
                }
            }
        }
        return entry.oldGraphData;
    }
    
    return {
        undoData,
        clearUndoData,
        addUndoLevel,
        undoToLevel
    }
}
